export class PaginationWrapper<T>{
  result: T[]
  page:number
  total:number
    constructor(page, total, result){
      this.page=page;
      this.total=total;
      this.result=result;
  }
}